<article
  appAnimateOnScroll
  class="card text-center shadow-sm border-0 h-100 weather-card"
>
  <div class="card-body py-3">
    <p class="mb-3 fw-semibold text-muted small">{{ date }}</p>
    <div class="d-flex justify-content-around align-items-center mb-2">
      <div>
        <i
          class="fa-solid fa-temperature-arrow-down text-info"
          aria-hidden="true"
        ></i>
        <p class="mb-0 small">
          <strong>{{ tempMin }}°C</strong>
        </p>
        <p class="mb-0 text-muted" style="font-size: 0.7rem">Min</p>
      </div>
      <div>
        <i
          class="fa-solid fa-temperature-arrow-up text-danger"
          aria-hidden="true"
        ></i>
        <p class="mb-0 small">
          <strong>{{ tempMax }}°C</strong>
        </p>
        <p class="mb-0 text-muted" style="font-size: 0.7rem">Max</p>
      </div>
    </div>
    <div class="mt-2 pt-2 border-top">
      <i class="fa-solid fa-cloud-rain text-info" aria-hidden="true"></i>
      <p class="mb-0 small">
        <strong>{{ rainfall }} mm</strong>
      </p>
      <p class="mb-0 text-muted" style="font-size: 0.7rem">Chuva</p>
    </div>
  </div>
</article>
